import { createContext } from 'react';

var DEFAULT_CLASS_PREFIX = "t";
var DEFAULT_LOCALE = "zh-CN";
var ConfigContext = /*#__PURE__*/createContext({
  classPrefix: DEFAULT_CLASS_PREFIX,
  locale: DEFAULT_LOCALE
});

export default ConfigContext;
export { DEFAULT_CLASS_PREFIX, DEFAULT_LOCALE };
//# sourceMappingURL=config-context.js.map
